import { useContext, createContext } from 'react'

export const SocketConnectionContext = createContext(null)

export const useConnectionContext = () => {
  return useContext(SocketConnectionContext)
}
